



































import ThgBillingOverviewCard from "@/components/thg/ThgBillingOverviewCard.vue";
import LayoutReport from "@/layouts/LayoutReport.vue";
import { Component, Vue } from "vue-property-decorator";
import { BillingModule } from "@/store/modules/billing.store";

@Component({
  components: {
    ThgBillingOverviewCard,
    LayoutReport
  }
})
export default class ThgBillingOverview extends Vue {
  isLoading = false;

  async mounted() {
    await this.loadBillings();
  }

  async loadBillings() {
    this.isLoading = true;
    try {
      await BillingModule.setMyBillings();
    } catch (e) {
      this.$toast((e as any).message);
    } finally {
      this.isLoading = false;
    }
  }
}
